export const VALIDATION_ERROR = '/errors/validation-error'
export const INFO_EDIT_FORM_NAME = 'info-edit-form'
